import { LOGOUT, REHYDRATE, CHOOSE_COMPANY } from "@Actions/types";

export default function reducer(
	state = {
		types: [],
	},
	action
) {
	const { payload, type } = action;
	switch (type) {
		case LOGOUT: {
			return {
				...state,
				types: [],
			};
		}

		case REHYDRATE: {
			return {
				...state,
				types: payload.data.types.types,
			};
		}

		case CHOOSE_COMPANY: {
			return {
				...state,
				types: payload.data.types,
			};
		}

		default:
			return state;
	}
}
